import React from 'react';
import { BadgeCheckIcon, CircleDashedIcon, CircleSlashIcon } from 'lucide-react';
import { dateWithYear } from '../../utils/format';
import type { Verification } from '../../types/chef';
const icons = {
  verified: <BadgeCheckIcon className="h-4 w-4 text-primary" aria-hidden="true" data-id="element-430" data-mp="3qvweagilx0a7" />,
  pending: <CircleDashedIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-431" data-mp="3vwk634entl5h" />,
  missing: <CircleSlashIcon className="h-4 w-4 text-ink-3" aria-hidden="true" data-id="element-432" data-mp="4pzhrsfzorc5" />
};
const statusLabel = {
  verified: 'Verified',
  pending: 'In review',
  missing: 'Not provided'
};
export function VerificationList({
  items
}: {
  items: Verification[];
}) {
  return <ul className="divide-y divide-hairline" data-id="element-433" data-mp="egcai7xyjqtd">
      {items.map(item => <li key={item.kind} className="flex items-start gap-3 py-3 first:pt-0 last:pb-0" data-id="element-434" data-mp="ifulaaw2elih">
          <span className="mt-0.5" data-id="element-435" data-mp="nha4ryilgjyr">{icons[item.status]}</span>
          <div className="min-w-0 flex-1" data-id="element-436" data-mp="sfbrctf8b1ez">
            <div className="flex flex-wrap items-baseline justify-between gap-2" data-id="element-437" data-mp="sg3klxlcsn23">
              <p className="text-sm font-medium text-ink" data-id="element-438" data-mp="2cnp5ujjj8oqj">{item.label}</p>
              <p className="text-[12px] text-ink-3" data-id="element-439" data-mp="27om1z2fagok5">
                {statusLabel[item.status]}
                {item.verifiedOn ? ` · ${dateWithYear(item.verifiedOn)}` : ''}
              </p>
            </div>
            <p className="mt-0.5 text-[13px] text-ink-2" data-id="element-440" data-mp="1yo7dju712tcf">{item.detail}</p>
          </div>
        </li>)}
    </ul>;
}